import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
import { thunk as thunkMiddleware } from "redux-thunk";

export default function configureStore(initialState) {
  return createStore(rootReducer, initialState, applyMiddleware(thunkMiddleware));
}
